import pagePreloaderManager from "../../../services/managers/page-preloader";

export const onDownloadClick = (state, action) => {
  pagePreloaderManager.hide();
  return state;
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-download/action-handlers.js